/* eslint-disable import/prefer-default-export */
export function mergeIfEmpty(base, incoming) {
  const isEmpty = value => value === null
        || value === undefined
        || value === ''
        || (Array.isArray(value) && value.length === 0)

  const isPlainObject = value => value !== null
        && typeof value === 'object'
        && !Array.isArray(value)

  const merge = (baseObj, incomingObj) => {
    const out = { ...baseObj }

    Object.keys(incomingObj).forEach(key => {
      const baseVal = out[key]
      const incomingVal = incomingObj[key]

      // Recursively merge nested objects
      if (isPlainObject(baseVal) && isPlainObject(incomingVal)) {
        out[key] = merge(baseVal, incomingVal)

        return
      }

      // Incoming wins whenever it has a value
      if (!isEmpty(incomingVal)) {
        out[key] = incomingVal
      }
    })

    return out
  }

  return merge(base, incoming)
}
